
const getFileNameWithoutExtension = (fileName='') => {
    
    if(!fileName || typeof fileName !=='string') {
        return fileName;
    }
    return fileName.substring(0, fileName.lastIndexOf('.')) || fileName
}

export {getFileNameWithoutExtension} 